import { ApprovalState } from '@/models/approval.model';
import { ApprovalsService } from '@/services/api/approvals.service';
import { BinderService } from '@/services/api/binder.service';
import { AppAuthService } from '@/services/app/auth.service';
import { BinderDialogService } from '@/services/app/binder-dialog.service';
import { SelectedDocService } from '@/services/app/selected-doc.service';
import { SignHistoryService } from '@/services/app/sign-history.service';
import { UserAccessService } from '@/services/app/user-access.service';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ToolbarModule } from 'primeng/toolbar';
import { MessageModule } from 'primeng/message';
import { DialogModule } from 'primeng/dialog';
import { FormsModule } from '@angular/forms';
import { TextareaModule } from 'primeng/textarea';
import { BinderLockService } from '@/services/app/binder-lock.service';

interface approvalState {
  valid: boolean;
  state: ApprovalState;
  stateText: string;
  severity: string;
  class: {
    [klass: string]: any;
  } | null | undefined;
}

@Component({
  selector: 'app-approval-banner',
  imports: [
    ToolbarModule,
    ButtonModule,
    CommonModule,
    MessageModule,
    DialogModule,
    FormsModule,
    TextareaModule
  ],
  template: `
<div *ngIf="bannerState.show" class="approval-banner-container mb-0">
  <div class="approval-banner m-0" [ngClass]="[bannerState.class, bannerState.severity]">
    <div class="approval-banner-content">
      <div class="approval-banner-text">
        <h4>{{ bannerState.text }}</h4>
      </div>
      <div class="approval-banner-actions">
        <p-button
          icon="pi pi-eye"
          severity="secondary"
          label="View PDF"
          class="mr-2"
          (click)="showPDFPreview()">
        </p-button>

        <p-button
          *ngIf="bannerState.actions?.includes('Cancel Request')"
          icon="pi pi-times"
          severity="secondary"
          label="Cancel"
          class="mr-2"
          (click)="confirmCancel($event)">
        </p-button>

        <p-button
          *ngIf="bannerState.actions?.includes('Make Changes')"
          icon="pi pi-pencil"
          severity="warn"
          label="Make Changes"
          class="mr-2"
          (click)="makeChanges()">
        </p-button>

        <p-button
          *ngIf="bannerState.actions?.includes('Cancel Drafting')"
          icon="pi pi-ban"
          severity="danger"
          label="Cancel Drafting"
          class="mr-2"
          (click)="cancelDrafting($event)">
        </p-button>

        <p-button
          *ngIf="bannerState.actions?.includes('Request Signatures')"
          icon="pi pi-envelope"
          severity="success"
          label="Request Signatures"
          class="mr-2"
          (click)="requestSignatures()">
        </p-button>

        <p-button
          *ngIf="bannerState.actions?.includes('Cancel Signing')"
          icon="pi pi-ban"
          severity="danger"
          label="Cancel Signing"
          class="mr-2"
          (click)="confirmCancelSigning($event)">
        </p-button>

        <p-button
          *ngIf="bannerState.actions?.includes('Respond')"
          icon="pi pi-check-circle"
          severity="info"
          label="Respond"
          class="mr-2"
          (click)="showApprovalForm()">
        </p-button>
      </div>
    </div>
  </div>
</div>

<p-dialog header="Cancel Drafting" [modal]="true" [(visible)]="showCancelRequest">
    <span class="p-text-secondary block mb-8">Are you sure that you want to cancel the current drafting request? This will cancel the completed signature request and notify the drafting team. Please leave a note for the drafting team.</span>

    <div class="flex items-center gap-4 mb-8">
        <!-- <label for="message" class="font-semibold w-24">Message</label> -->
        <textarea pTextarea id="message" class="flex-auto" autocomplete="off" [(ngModel)]="message" rows="5" cols="30" placeholder="Enter a message for the drafting team"></textarea>
    </div>
    <div class="flex justify-end gap-2">
        <p-button label="Cancel" severity="secondary" (click)="showCancelRequest = false" />
        <p-button label="Send Cancel Request" (click)="submitCancelDrafting()" />
    </div>
</p-dialog>

    `,
  styleUrl: './styles/binder-approval-banner.component.scss'
})
export class ApprovalBannerComponent {
  approvalFormVisible: boolean = false;
  pdfSrc: string = 'https://spexisstorage.blob.core.windows.net/binderpdfs/1029.pdf';
  approvalAccess: boolean = false;
  message: string = '';
  showCancelRequest: boolean = false;
  loading: boolean = false;

  constructor(
    public approvalsService: ApprovalsService,
    private selectedDocService: SelectedDocService,
    private currentBinderService: BinderService,
    private binderDialogService: BinderDialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    public userAccessService: UserAccessService,
    private signHistoryService: SignHistoryService,
    private authService: AppAuthService,
    private binderLockService: BinderLockService
  ) {

  }

  get bannerState() {
    return this.approvalsService.getBannerState();
  }

  // getApprovalText(): string {
  //   const state = this.approvalsService.approvalState();
  //   switch (state) {
  //     case 'approved':
  //       return 'This binder has been approved.';
  //       break;
  //     case 'rejected':
  //       return 'This binder has been rejected.';
  //       break;
  //     case 'cancelled':
  //       return 'This binder has been cancelled.';
  //       break;
  //     case 'signing':
  //       return 'This binder is being signed.';
  //       break;
  //     case 'signed':
  //       return 'This binder has been signed.';
  //       break;
  //     default:
  //       return 'This binder has been submitted for approval. Please respond to the request.';
  //   }
  // }

  showDraftCancel() {
    this.showCancelRequest = true;
    this.message = '';
  }

  // setState(state: ApprovalState, status: number) {
  //   const isValid = this.approvalsService.currentRequest() !== null && state !== 'cancelled' && state !== 'rejected' && status > 3;
  //   const text = this.getApprovalText();
  //   this.approvalStatus = {
  //     valid: isValid,
  //     state: state,
  //     stateText: text,
  //     class: { 'background-image': `linear-gradient(to right, #00000000, var(${this.getColorClass(state)}))` },
  //     severity: 'info'
  //   }

  // }

  submitCancelDrafting() {
    this.loading = true;
    const userName = this.authService.userData()?.DisplayName;
    this.signHistoryService.cancelDraftingRequest(this.currentBinderService.currentBinder().BinderID, this.message, userName || 'Unknown User');
    this.showCancelRequest = false;
  }

  cancelDrafting(event: Event) {
    this.showDraftCancel();
  }

  cancelRequest() {
    this.loading = true;
    const request = this.approvalsService.currentRequest();
    const state = this.approvalsService.approvalState();
    console.log('state', state);
    if (state === 'signing') {
      this.signHistoryService.cancelSignatureRequest(this.currentBinderService.currentBinder().BinderID);
    } else if (request) {
      this.approvalsService.cancelApproval(request.approvalId, request.binderId).subscribe(
        (data: any) => {
          this.messageService.add({ severity: 'info', summary: 'Success', detail: 'Approval Cancelled' });
          this.userAccessService.setBinderEditAccess(true);
          this.currentBinderService.setStatus(3);
          this.approvalsService.cancelRequest();
          this.loading = false;
        },
        (error: any) => {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Approval Request Failed' });
        }
      );
    } else if (state === 'cancelled') {
      this.currentBinderService.updateBinder(this.currentBinderService.currentBinder().BinderID, {
        ProjectStatus: 3
      }).subscribe(
        (data: any) => {
          this.messageService.add({ severity: 'info', summary: 'Success', detail: 'Approval Cancelled' });
          this.userAccessService.setBinderEditAccess(true);
          this.currentBinderService.setStatus(3);
          this.approvalsService.cancelRequest();
          this.loading = false;
        }
      );
    }
  }

  getColorClass(state: ApprovalState): string {
    return state === 'pending' ? '--primary-800' : state === 'approved' ? '--green-800' : state === 'rejected' ? '--danger-800' : state === 'cancelled' ? '--secondary-800' : '--secondary-800';
  }

  confirmCancel(event: Event) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'This will cancel the current approval request. Are you sure that you want to proceed?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: "none",
      rejectIcon: "none",
      acceptLabel: 'Yes',
      rejectLabel: 'No',
      rejectButtonStyleClass: "p-button-text",
      accept: () => {
        this.cancelRequest()
      },
      reject: () => {
        // this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
      }
    });
  }

  confirmCancelSigning(event: Event) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'This will cancel the current signature request. Are you sure that you want to proceed?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: "none",
      rejectIcon: "none",
      acceptLabel: 'Yes',
      rejectLabel: 'No',
      rejectButtonStyleClass: "p-button-text",
      accept: () => {
        this.cancelSigning()
      },
      reject: () => {
        // this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
      }
    });
  }

  showPDFPreview() {
    this.selectedDocService.setSelectionById(1);
    this.binderDialogService.toggleDrawer('docs', 'Files', true);
  }

  showApprovalForm() {
    this.binderDialogService.toggleDialog('Respond to Approval', 'respond', true);
  }

  makeChanges() {
    this.cancelRequest();
  }

  requestSignatures() {
    this.binderDialogService.toggleDialog('Signature Request', 'signatures', true, 'center');
  }

  cancelSigning() {
    this.binderLockService.handleSignUnlock(this.currentBinderService.currentBinder().BinderID);
  }

}
